var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon24Telegram = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5 3C17.4706 3 21.5 7.02944 21.5 12C21.5 16.9706 17.4706 21 12.5 21C7.52944 21 3.5 16.9706 3.5 12C3.5 7.02944 7.52944 3 12.5 3ZM16.1797 8.41772C15.8412 8.42372 15.3214 8.60505 12.8223 9.64453L7.57373 11.9048C7.14786 12.0742 6.92471 12.2401 6.9043 12.4021C6.86528 12.7132 7.31336 12.81 7.87695 12.9932C8.33643 13.1425 8.9545 13.3172 9.27588 13.3242C9.56735 13.3305 9.89301 13.2105 10.2522 12.9639C12.7034 11.3092 13.9689 10.4726 14.0483 10.4546C14.1043 10.4421 14.1818 10.4263 14.2344 10.4729C14.2869 10.5196 14.2815 10.608 14.2761 10.6318C14.2316 10.8217 11.9324 12.9135 11.7969 13.054C11.2905 13.5799 10.7143 13.9018 11.6028 14.4873L13.6111 15.8364C14.1173 16.1682 14.5145 16.562 15.0371 16.5139C15.2777 16.4917 15.5262 16.2654 15.6523 15.5911C15.9505 13.9971 16.5364 10.5439 16.6719 9.12085C16.6837 8.99616 16.6685 8.83638 16.6565 8.76636C16.6445 8.69634 16.6194 8.5963 16.5283 8.52246C16.4205 8.43514 16.2541 8.41641 16.1797 8.41772Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon24Telegram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Icon24Telegram.80b2cc896d801755ed6922c96281e6f2.svg";